<template>
  <div class="player-volume">
    <span
      v-if="volumeControl.value > 0"
      class="player-volume__icon iconfont iplayer-volume"
      @click="volumeControl.mute()"
    ></span>
    <span
      v-else
      class="player-volume__icon iconfont iplayer-mute"
      @click="volumeControl.unmute()"
    ></span>

    <vue-slider
      v-model="value"
      :value="volumeControl.value"
      :min="0"
      :max="100"
      class="player__audioplayer player__volume-slider"
      :dragOnClick="true"
      :interval="1"
      tooltip="none"
      @change="inputChange"
    />
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

import type { VolumeControl } from '@/services/player'
import VueSlider from 'vue-slider-component'

const props = defineProps<{
  volumeControl: VolumeControl
}>()

const value = ref<number>()

onBeforeMount(() => {
  updateVolume()
})

function inputChange(value: number): void {
  const percent = value / 100
  if (props.volumeControl.value !== percent && !isNaN(percent)) {
    props.volumeControl.change(percent)
  }
}

function updateVolume(): void {
  // When we use regular Vue approach to render position and duration,
  // the value sometimes rendered multiple times.
  // For example, in Chrome, mobile width, if we click forward (+15sec)
  // button 3 times quickly and then start the playback, the position
  // value will be duplicated.
  // Similarly, when the audio is playing, if we select the position text
  // with mouse, it will be duplicated.
  // I think this is Vue bug, especially since it is reproduced just with
  // text selection - we do not do anything here.
  // I was also able to reproduce it with simple counter increasing in
  // `setInterval` handler.
  // On the other hand, it might be a combination of data setup and HTML
  // structure and can be caused by something in our code.
  //
  // As a last resort solution, I update timings manually here.
  // See #2150.
  //
  // We also save current position and duration into component fields
  // for tests, as they are invisible in HTML.

  if (props.volumeControl.value && !isNaN(props.volumeControl.value)) {
    value.value = props.volumeControl.value * 100
  }
}
</script>
